import { ALL_ACCESSES } from '@/common/constants/allAccesses';
import { ACCESSES } from '@/common/constants/accesses';

export const ROLES = Object.keys(ACCESSES).map((role) => {
	return { label: role, value: role };
});

export const ACCESS = ALL_ACCESSES.map((access) => {
	return { label: access, value: access };
});

export const CONSULTANT_ROLE = 'CALL_CENTER_OPERATOR';

export const CONSULTANT_ACCESSES = ['CONSULTANT_COMMON', 'COMMON'];

export const MANAGER_ROLE = 'CALL_CENTER_MANAGER';
export const CONSULTNAT_ROLE = 'CONSULTANT';

export const ROLE_HIDDEN_FIELDS = {
	ADMIN: [CONSULTNAT_ROLE],
	HEAD_CC_MANAGER: [CONSULTNAT_ROLE],
	HEAD_CC_CONCULTANT: [CONSULTNAT_ROLE],
	FINANCE_ANALYST: [CONSULTNAT_ROLE],
	SUPPORT: [CONSULTNAT_ROLE],
	ANALYST: [CONSULTNAT_ROLE],
	CALL_CENTER_OPERATOR: [MANAGER_ROLE],
	CALL_CENTER_MANAGER: [],
};

export const ROLE_VALUES = {
	ADMIN: 'ADMIN',
	HEAD_CC_MANAGER: 'HEAD_CC_MANAGER',
	HEAD_CC_CONCULTANT: 'HEAD_CC_CONCULTANT',
	FINANCE_ANALYST: 'FINANCE_ANALYST',
	SUPPORT: 'SUPPORT',
	ANALYST: 'ANALYST',
	CALL_CENTER_OPERATOR: 'CALL_CENTER_OPERATOR',
	CALL_CENTER_MANAGER: 'CALL_CENTER_MANAGER',
};
